import { Injectable } from '@angular/core';
import { Timestamp, addDoc, collection, deleteDoc, doc, getDocs, getFirestore, query, updateDoc, where } from 'firebase/firestore';

import { ownedCollection, withCurrentOwner } from '../../utils/firestore-ownership';
import { Month } from './finance.model';

export type FinanceCollection =
  'FinanceCategories' | 'Incomes' | 'Bills' | 'Expenses' | 'Cards' | 'CardItems' | 'CardStatements';

// Firestore access shared by the Finances screens; every record belongs to the current user
@Injectable({
  providedIn: 'root'
})
export class FinanceStoreService {

  // Equality filters only (ownerUid + month), so no composite index is needed
  async list<T>(name: FinanceCollection, month?: Month): Promise<T[]> {
    const q = month ? query(ownedCollection(name), where('month', '==', month)) : ownedCollection(name);
    const docs = await getDocs(q);
    return docs.docs.map(d => ({ ...d.data(), id: d.id }) as T);
  }

  async add(name: FinanceCollection, record: object): Promise<string> {
    const created = await addDoc(collection(getFirestore(), name), {
      ...withCurrentOwner(record), created_on: Timestamp.now(), modified_on: Timestamp.now()
    });
    return created.id;
  }

  async update(name: FinanceCollection, record: { id: string }): Promise<void> {
    await updateDoc(doc(getFirestore(), name, record.id), { ...withCurrentOwner(record), modified_on: Timestamp.now() });
  }

  async remove(name: FinanceCollection, id: string): Promise<void> {
    await deleteDoc(doc(getFirestore(), name, id));
  }
}
